import React from "react";

import {getGardenerLabel} from "utils";
import {Assignee} from "v2/api/Records";
import {prepareUserData} from "v2/api/Users";

export const apiAssignee = (assignee) => {
  return new Assignee(prepareUserData(assignee));
};

export const getAssignmentsOptions = (data, routeId) => {
  return data
    .map(item => {
      const label = getGardenerLabel(item);
      return {
        htmlLabel: item.assignedTo && item.assignedTo !== routeId ?
          <span>* {label}</span> :
          label,
        label: item.fullName || item.email,
        value: item.id,
      };
    })
    .toArray();
};

export default {
  apiAssignee,
  getAssignmentsOptions,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Assignees.js
 **/